module.exports = __webpack_public_path__ + "static/media/filter-icon-selected.359018d8.svg";